export enum SlotsEnum {
  Title = 'title',
  Subtitle = 'subtitle',
  Subtitle2 = 'subtitle2',
  BackgroundImage = 'background_image',
}
